'use client';

import React from 'react';
import { VideoStream } from './VideoStream';
import { LiveImageStatus } from '../../../data/liveMessageData/liveMessage';
import { AdvancedImage } from '@cloudinary/react';
import { ChatStatus } from '../../../data/globalChatState';
import { useGlobalChatState } from '../../../hooks/useGlobalChatState';

interface StreamingPanelProps {
  activeBackgroundImage: {
    imageUri: string | null;
    imageData: any | null; // Cloudinary image object
    imageRawData: HTMLImageElement | null;
    loadingStatus: LiveImageStatus;
  };
}

export function StreamingPanel({
  activeBackgroundImage 
}: StreamingPanelProps) {
  const [globalState, globalActions] = useGlobalChatState();
  const { chatStatus } = globalState;
  return (
    // Container with full height for proper positioning - flex container for centering
    <div className="relative w-full h-full flex-shrink-0 flex justify-center items-start">

      {/* Video Section or Image Section - Strict 9:16 aspect ratio, height grows to fullest or 90% of the screen */}
      <div 
        className="relative h-full"
        style={{
          aspectRatio: '9/16',
          width: 'auto',
          maxHeight: '100%',
          zIndex: 2
        }}
      >
        {chatStatus !== ChatStatus.LIVE ? (
          activeBackgroundImage.loadingStatus === LiveImageStatus.LOADED ? (
            <div className="w-full h-full rounded-l-[5px] shadow-lg overflow-hidden">
              <AdvancedImage
                cldImg={activeBackgroundImage.imageData}
                alt="Character image"
                className="w-full h-full object-cover object-center"
                style={{
                  filter: 'blur(2px) brightness(0.6)',
                }}
              />
            </div>
          ) : (
            <div className="w-full h-full rounded-l-[5px] shadow-lg bg-gray-800 animate-pulse flex items-center justify-center">
              <div className="w-16 h-16 border-4 border-gray-600 border-t-gray-400 rounded-full animate-spin" />
            </div>
          )
        ) : (
          <VideoStream />
        )}
      </div>

      {/* Bottom Blur Container - 15% height, fixed at bottom, higher z-index */}
      {/* <div 
        className="absolute bottom-0 left-0 right-0 w-full"
        style={{
          height: '15%',
          zIndex: 3,
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }}
      /> */}
    </div>
  );
} 